<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <fiscal-years-select
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- RADIO TAX MODE -->
        <el-form-item
            :label="$t.__('common.actions.select_tax_display')"
            class="mb-4"
            prop="taxMode"
        >
            <el-radio-group v-model="form.taxMode">
                <div class="mt-2">
                    <el-radio label="exc">{{ $l10n.__('HT') }}</el-radio>
                </div>
                <div>
                    <el-radio label="inc" class="mt-3">{{ $l10n.__('TTC') }}</el-radio>
                </div>
            </el-radio-group>
        </el-form-item>
        <!-- SUBMIT -->
        <div class="aright mt-5">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="close"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submitForm"
            />
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    mixins: [SettingsFormMixin],
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    data() {
        return {
            unreconciledRules: {
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
    mounted() {
        this.$emit('set-rules', this.unreconciledRules);
    },
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
};
</script>
